var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDownUk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.8449 20.3391L13.6418 19.5422L22.6418 10.5469L23.4387 9.75L21.8449 8.16094L21.048 8.95781L12.8449 17.1609L4.6418 8.95312L3.84492 8.15625L2.25586 9.75L3.05273 10.5469L12.048 19.5469L12.8449 20.3438V20.3391Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownUk);
export default __webpack_public_path__ + "static/media/chevron-down-uk.b5eac51e74a0d8741a91882547628ab4.svg";
export { ForwardRef as ReactComponent };